module.exports = __webpack_public_path__ + "img/step2img.048a6da5.png";